<template>
  <!-- 指标对比 -->
  <div class="m-wrapper zbdb" style="border-radius: 0px">
    <div style="position: relative">
      <div class="titleBox">
        <span class="bigTitleInfo">Economic Growth Comparison</span>
        <span class="chenge-dir">
          <span style="font-size: 13px; color: #000">The following data is for reference only</span>
          <el-switch
            v-model="isAllData"
            @change="changeAllData()"
            style="margin-left: 50px; margin-right: 10px"
          ></el-switch>
          <span style="font-size: 14px; color: #000">All data</span>
          <el-tooltip placement="top-end">
            <div slot="content" style="color: #fff">
              Off: 2-consecutive-year data compare<br />
              On: all data compare
            </div>
            <i
              class="el-icon-info"
              style="margin-left: 10px; cursor: pointer"
            ></i>
          </el-tooltip>
        </span>
      </div>
    </div>
    <div class="center" style="border-top: 1px solid #e6e6e6">
      <!-- 搜索栏 -->
      <div class="top">
        <div class="top-form">
          <div class="item">
            <span style="color: #000">FTZ：</span>
            <el-select
              v-model="zmqModelDisplay"
              @visible-change="zmqOnchange"
              multiple
              placeholder="Select"
            >
              <el-option
                v-for="item in zmqOptionDisplay"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item zb">
            <span style="color: #000">Index：</span>
            <el-select
              v-model="zbModelDisplay"
              @visible-change="zbOnchange"
              multiple
              placeholder="Select"
            >
              <el-option
                v-for="item in zbOptionDisplay"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <year-select
              :yearStartTime="yearStartTime"
              :yearEndTime="yearEndTime"
              :years="yearData"
              @changeStart="yearStartOnchange"
              @changeEnd="yearEndOnchange"
              @func="changeYears"
            />
          </div>
        </div>
        <div class="top-botton">
          <el-button type="primary" @click="submit()">Go</el-button>
          <el-button
            type="primary"
            style="margin-left: 10px"
            @click="downLoadExcelzb('Economic Growth Comparison.xlsx')"
            >download</el-button
          >
        </div>
      </div>
      <!-- 图表 -->
      <div class="bottom">
        <div v-for="i in charZbDisplay" :key="i" class="item">
          <div class="box" v-if="i === 'Total Import&Export'">
            <div class="check">
              <img
                v-if="
                  charDataDisplay.tmxList !== null &&
                  charDataDisplay.tmxList !== undefined &&
                  charDataDisplay.tmxList.length > 0 &&
                  BarOrLine.jckze
                "
                @click="BarOrLine.jckze = false"
                src="../../../assets/images/fta/targetContrastSearch/bz21.svg"
              />
              <img
                v-if="
                  charDataDisplay.tmxList !== null &&
                  charDataDisplay.tmxList !== undefined &&
                  charDataDisplay.tmxList.length > 0 &&
                  !BarOrLine.jckze
                "
                @click="BarOrLine.jckze = true"
                src="../../../assets/images/fta/targetContrastSearch/bz23.svg"
              />
              <img
                v-if="
                  charDataDisplay.tmxList !== null &&
                  charDataDisplay.tmxList !== undefined &&
                  charDataDisplay.tmxList.length > 0 &&
                  BarOrLine.jckze
                "
                @click="BarOrLine.jckze = false"
                src="../../../assets/images/fta/targetContrastSearch/bz19.svg"
              />
              <img
                v-if="
                  charDataDisplay.tmxList !== null &&
                  charDataDisplay.tmxList !== undefined &&
                  charDataDisplay.tmxList.length > 0 &&
                  !BarOrLine.jckze
                "
                @click="BarOrLine.jckze = true"
                src="../../../assets/images/fta/targetContrastSearch/bz22.svg"
              />
            </div>
            <chart-bar
              v-if="BarOrLine.jckze"
              :id="'jckze1'"
              :title="'Total Import&Export（billion CNY）'"
              :zb="charZbDisplay"
              :zmq="charZmqDisplay"
              :year="charYearDisplay"
              :data="
                charDataDisplay.tmxList !== null ? charDataDisplay.tmxList : []
              "
            />
            <char-line
              v-else
              :id="'jckze2'"
              :title="'Total Import&Export（billion CNY）'"
              :zb="charZbDisplay"
              :zmq="charZmqDisplay"
              :year="charYearDisplay"
              :data="
                charDataDisplay.tmxList !== null ? charDataDisplay.tmxList : []
              "
            />
          </div>
          <div class="box" v-if="i === 'Total FDI'">
            <div class="check">
              <img
                v-if="
                  charDataDisplay.fgninvestList !== null &&
                  charDataDisplay.fgninvestList !== undefined &&
                  charDataDisplay.fgninvestList.length > 0 &&
                  BarOrLine.wztzze
                "
                @click="BarOrLine.wztzze = false"
                src="../../../assets/images/fta/targetContrastSearch/bz21.svg"
              />
              <img
                v-if="
                  charDataDisplay.fgninvestList !== null &&
                  charDataDisplay.fgninvestList !== undefined &&
                  charDataDisplay.fgninvestList.length > 0 &&
                  !BarOrLine.wztzze
                "
                @click="BarOrLine.wztzze = true"
                src="../../../assets/images/fta/targetContrastSearch/bz23.svg"
              />
              <img
                v-if="
                  charDataDisplay.fgninvestList !== null &&
                  charDataDisplay.fgninvestList !== undefined &&
                  charDataDisplay.fgninvestList.length > 0 &&
                  BarOrLine.wztzze
                "
                @click="BarOrLine.wztzze = false"
                src="../../../assets/images/fta/targetContrastSearch/bz19.svg"
              />
              <img
                v-if="
                  charDataDisplay.fgninvestList !== null &&
                  charDataDisplay.fgninvestList !== undefined &&
                  charDataDisplay.fgninvestList.length > 0 &&
                  !BarOrLine.wztzze
                "
                @click="BarOrLine.wztzze = true"
                src="../../../assets/images/fta/targetContrastSearch/bz22.svg"
              />
            </div>
            <chart-bar
              v-if="BarOrLine.wztzze"
              :id="'wztzze1'"
              :title="'Total FDI（billion USD）'"
              :zb="charZbDisplay"
              :zmq="charZmqDisplay"
              :year="charYearDisplay"
              :data="
                charDataDisplay.fgninvestList !== null
                  ? charDataDisplay.fgninvestList
                  : []
              "
            />
            <char-line
              v-else
              :id="'wztzze2'"
              :title="'Total FDI（billion USD）'"
              :zb="charZbDisplay"
              :zmq="charZmqDisplay"
              :year="charYearDisplay"
              :data="
                charDataDisplay.fgninvestList !== null
                  ? charDataDisplay.fgninvestList
                  : []
              "
            />
          </div>
          <div class="box" v-if="i === 'Total New Foreign Company'">
            <div class="check">
              <img
                v-if="
                  charDataDisplay.newEntCountList !== null &&
                  charDataDisplay.newEntCountList !== undefined &&
                  charDataDisplay.newEntCountList.length > 0 &&
                  BarOrLine.xzwz
                "
                @click="BarOrLine.xzwz = false"
                src="../../../assets/images/fta/targetContrastSearch/bz21.svg"
              />
              <img
                v-if="
                  charDataDisplay.newEntCountList !== null &&
                  charDataDisplay.newEntCountList !== undefined &&
                  charDataDisplay.newEntCountList.length > 0 &&
                  !BarOrLine.xzwz
                "
                @click="BarOrLine.xzwz = true"
                src="../../../assets/images/fta/targetContrastSearch/bz23.svg"
              />
              <img
                v-if="
                  charDataDisplay.newEntCountList !== null &&
                  charDataDisplay.newEntCountList !== undefined &&
                  charDataDisplay.newEntCountList.length > 0 &&
                  BarOrLine.xzwz
                "
                @click="BarOrLine.xzwz = false"
                src="../../../assets/images/fta/targetContrastSearch/bz19.svg"
              />
              <img
                v-if="
                  charDataDisplay.newEntCountList !== null &&
                  charDataDisplay.newEntCountList !== undefined &&
                  charDataDisplay.newEntCountList.length > 0 &&
                  !BarOrLine.xzwz
                "
                @click="BarOrLine.xzwz = true"
                src="../../../assets/images/fta/targetContrastSearch/bz22.svg"
              />
            </div>
            <chart-bar
              v-if="BarOrLine.xzwz"
              :id="'xzwz1'"
              :title="'Total New Foreign Company'"
              :zb="charZbDisplay"
              :zmq="charZmqDisplay"
              :year="charYearDisplay"
              :data="
                charDataDisplay.newEntCountList !== null
                  ? charDataDisplay.newEntCountList
                  : []
              "
            />
            <char-line
              v-else
              :id="'xzwz2'"
              :title="'Total New Foreign Company'"
              :zb="charZbDisplay"
              :zmq="charZmqDisplay"
              :year="charYearDisplay"
              :data="
                charDataDisplay.newEntCountList !== null
                  ? charDataDisplay.newEntCountList
                  : []
              "
            />
          </div>
          <div class="box" v-if="i === 'Total Tax Revenue'">
            <div class="check">
              <img
                v-if="
                  charDataDisplay.taxList !== null &&
                  charDataDisplay.taxList !== undefined &&
                  charDataDisplay.taxList.length > 0 &&
                  BarOrLine.nsze
                "
                @click="BarOrLine.nsze = false"
                src="../../../assets/images/fta/targetContrastSearch/bz21.svg"
              />
              <img
                v-if="
                  charDataDisplay.taxList !== null &&
                  charDataDisplay.taxList !== undefined &&
                  charDataDisplay.taxList.length > 0 &&
                  !BarOrLine.nsze
                "
                @click="BarOrLine.nsze = true"
                src="../../../assets/images/fta/targetContrastSearch/bz23.svg"
              />
              <img
                v-if="
                  charDataDisplay.taxList !== null &&
                  charDataDisplay.taxList !== undefined &&
                  charDataDisplay.taxList.length > 0 &&
                  BarOrLine.nsze
                "
                @click="BarOrLine.nsze = false"
                src="../../../assets/images/fta/targetContrastSearch/bz19.svg"
              />
              <img
                v-if="
                  charDataDisplay.taxList !== null &&
                  charDataDisplay.taxList !== undefined &&
                  charDataDisplay.taxList.length > 0 &&
                  !BarOrLine.nsze
                "
                @click="BarOrLine.nsze = true"
                src="../../../assets/images/fta/targetContrastSearch/bz22.svg"
              />
            </div>
            <chart-bar
              v-if="BarOrLine.nsze"
              :id="'nsze1'"
              :title="'Total Tax Revenue（billion CNY）'"
              :zb="charZbDisplay"
              :zmq="charZmqDisplay"
              :year="charYearDisplay"
              :data="
                charDataDisplay.taxList !== null ? charDataDisplay.taxList : []
              "
            />
            <char-line
              v-else
              :id="'nsze2'"
              :title="'Total Tax Revenue（billion CNY）'"
              :zb="charZbDisplay"
              :zmq="charZmqDisplay"
              :year="charYearDisplay"
              :data="
                charDataDisplay.taxList !== null ? charDataDisplay.taxList : []
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import * as echarts from "echarts";
import ChartBar from "./CharBar.vue";
import CharLine from "./CharLine.vue";
import request from "../../../ftaUtils/http";
import YearSelect from "./YearSelect.vue";
import baseUrl from "../../../ftaUtils/baseUrl";
export default {
  components: {
    ChartBar,
    CharLine,
    YearSelect,
  },
  data() {
    return {
      // 用户 第一次 改变的下拉 数据 => zmq , zb , year
      first: "",
      // 下拉事件 是否调用接口
      onchange: true,
      zbEmpty: false,
      zmqEmpty: false,
      zbModel2: [],
      zbOption2: [],
      zmqModel2: [],
      zmqOption2: [],
      // 判断当前下拉 onchange 是否第一次
      count: 0,
      // 是否开启全部数据
      isAllData: false,
      // 所有下拉 带id 保存信息 唯一
      zbdbData: {},
      // 所有下拉框 选中绑定的数据
      zbdbModel: {},
      // 自贸区 下拉 选项
      zmqOption: [],
      // 自贸区 绑定 数据
      zmqModel: [],
      // 指标 下拉 选项
      zbOption: [],
      // 指标 绑定 数据
      zbModel: [],
      // 年份 选择器 选中的 开始日期 和 结束日期
      yearStartTime: "",
      yearEndTime: "",
      // 年份 选择器 下拉选项
      yearData: [],
      charDataDisplay: {},
      // 图标 渲染 指标数组
      charZbDisplay: [],
      // 图标 渲染 指标数组
      charZmqDisplay: [],
      // 图标 渲染 指标数组
      charYearDisplay: [],
      // 柱状图 或者 折线图
      BarOrLine: {
        jckze: true,
        wztzze: true,
        xzwz: true,
        nsze: true,
      },
      excel: {
        zbModel: [],
        zmqModel: [],
        yearStartTime: "",
        yearEndTime: "",
      },
    };
  },
  computed: {
    zmqZbEmpty() {
      return this.zmqModel.length === 0 && this.zbModel.length === 0;
    },
    zbModelDisplay: {
      set: function (val) {
        if (!this.zbEmpty) {
          this.zbModel = val;
        } else {
          this.zbModel2 = val;
        }
      },
      get: function () {
        return !this.zbEmpty ? this.zbModel : this.zbModel2;
      },
    },
    zmqModelDisplay: {
      set: function (val) {
        if (!this.zmqEmpty) {
          this.zmqModel = val;
        } else {
          this.zmqModel2 = val;
        }
      },
      get: function () {
        return !this.zmqEmpty ? this.zmqModel : this.zmqModel2;
      },
    },
    zbOptionDisplay() {
      return !this.zbEmpty ? this.zbOption : this.zbOption2;
    },
    zmqOptionDisplay() {
      return !this.zmqEmpty ? this.zmqOption : this.zmqOption2;
    },
    getYears() {
      let data = [];
      data.push(this.excel.yearStartTime);
      while (
        parseInt(data[data.length - 1]) < parseInt(this.excel.yearEndTime)
      ) {
        data.push((parseInt(data[data.length - 1]) + 1).toString());
        console.log(data);
      }
      console.log("getYears", data);
      return data;
    },
    ExcelData() {
      let data = [];
      this.excel.zmqModel.forEach((i) => {
        this.getYears.forEach((j) => {
          let item = {};
          item["zmq"] = i;
          item["years"] = j;
          this.excel.zbModel.forEach((k) => {
            if (
              this.charDataDisplay["tmxList"] !== null &&
              k === "Total Import&Export"
            ) {
              this.charDataDisplay["tmxList"].forEach((m) => {
                if (m["title"] === i && m["year"] === j) {
                  item[k] = m["total"];
                }
              });
            }
            if (
              this.charDataDisplay["fgninvestList"] !== null &&
              k === "Total FDI"
            ) {
              this.charDataDisplay["fgninvestList"].forEach((m) => {
                if (m["title"] === i && m["year"] === j) {
                  item[k] = m["total"];
                }
              });
            }
            if (
              this.charDataDisplay["newEntCountList"] !== null &&
              k === "Total New Foreign Company"
            ) {
              this.charDataDisplay["newEntCountList"].forEach((m) => {
                if (m["title"] === i && m["year"] === j) {
                  item[k] = m["total"];
                }
              });
            }
            if (this.charDataDisplay["taxList"] !== null && k === "Total Tax Revenue") {
              this.charDataDisplay["taxList"].forEach((m) => {
                if (m["title"] === i && m["year"] === j) {
                  item[k] = m["total"];
                }
              });
            }
          });
          data.push(item);
        });
      });
      return data;
    },
    ExcelFields() {
      let fields = {};
      fields["year"] = "years";
      fields["FTZ"] = "zmq";
      this.excel.zbModel.forEach((i) => {
        if (i === "Total Import&Export") fields[i + "(billion CNY)"] = i;
        if (i === "Total FDI") fields[i + "(billion USD)"] = i;
        if (i === "Total New Foreign Company") fields[i] = i;
        if (i === "Total Tax Revenue") fields[i + "(billion CNY)"] = i;
      });
      return fields;
    },
  },
  methods: {
    zmqOnchange(e) {
      if (!e) {
        if (!this.isAllData) {
          if (this.count === 0) {
            this.first = "zmq";
            let ftaIdStr = "";
            this.zmqModel.forEach((i) => {
              let item = this.zbdbData["fta"].find((j) => j.val === i);
              if (ftaIdStr === "") {
                ftaIdStr = item["id"];
              } else {
                ftaIdStr = ftaIdStr + "," + item["id"];
              }
            });
            this.zbModel = [];
            // this.yearStartTime = "";
            // this.yearEndTime = "";
            this.queryOnchange(
              ftaIdStr,
              "",
              this.yearStartTime,
              this.yearEndTime
            );
            this.count++;
          } else {
            if (this.zmqModel.length > 0) {
              // if (this.onchange) {
              let ftaIdStr = "";
              this.zmqModel.forEach((i) => {
                let item = this.zbdbData["fta"].find((j) => j.val === i);
                if (ftaIdStr === "") {
                  ftaIdStr = item["id"];
                } else {
                  ftaIdStr = ftaIdStr + "," + item["id"];
                }
              });
              if (this.first === "zmq") {
                let ftaIdStr = "";
                this.zmqModel.forEach((i) => {
                  let item = this.zbdbData["fta"].find((j) => j.val === i);
                  if (ftaIdStr === "") {
                    ftaIdStr = item["id"];
                  } else {
                    ftaIdStr = ftaIdStr + "," + item["id"];
                  }
                });
                // this.zbModel = [];
                // this.yearStartTime = "";
                // this.yearEndTime = "";
                this.queryOnchange(
                  ftaIdStr,
                  "",
                  this.yearStartTime,
                  this.yearEndTime
                );
              }
              if (this.first === "zb") {
                // if (this.zbModel.length === 0) {
                  let yearStrat = this.yearStartTime;
                  let yearEnd = this.yearEndTime;
                  this.queryOnchange(ftaIdStr, "", yearStrat, yearEnd);
                // } 
              }
              if (this.first === "year") {
                let yearStrat = this.yearStartTime;
                let yearEnd = this.yearEndTime;
                this.queryOnchange(ftaIdStr, "", yearStrat, yearEnd);
              }
              // this.onchange = false;
              // }
            } else {
              if (this.zbModel.length === 0) {
                this.queryOnchange(
                  "",
                  "",
                  this.yearStartTime,
                  this.yearEndTime
                );
              } else {
                let indStr = "";
                this.zbModel.forEach((i) => {
                  let item = this.zbdbData["zb"].find((j) => j.val === i);
                  if (indStr === "") {
                    indStr = item["id"];
                  } else {
                    indStr = indStr + "," + item["id"];
                  }
                });
                this.queryOnchange(
                  "",
                  indStr,
                  this.yearStartTime,
                  this.yearEndTime
                );
                console.log("ppppppp");
              }
            }
          }
        }
      }
    },
    // 下拉查询接口
    queryOnchange(ftaIdStr = "", indStr = "", yearStart = "", yearEnd = "") {
      if (yearStart !== null && yearEnd === null) {
        this.yearEndTime =
          this.yearData[this.yearData.length - 1]["val"].toString();
        yearEnd = this.yearEndTime;
      }
      if (yearStart === null && yearEnd !== null) {
        this.yearStartTime = this.yearData[0]["val"].toString();
        yearStart = this.yearStartTime;
      }
      if (yearStart === null && yearEnd === null) {
        this.yearEndTime = this.charYearDisplay[1].toString();
        this.yearStartTime = this.charYearDisplay[0].toString();
        yearEnd = this.yearEndTime;
        yearStart = this.yearStartTime;
      }
      request(
        "get",
        `${baseUrl.base_1}/indexCompare/queryOnchange?ftaIdStr=${ftaIdStr}&indStr=${indStr}&yearStart=${yearStart}&yearEnd=${yearEnd}`
      ).then((res) => {
        if (res.resCode === 0) {
          // 使用 自贸区 调用接口
          if (
            ftaIdStr !== "" &&
            indStr === "" &&
            yearStart === "" &&
            yearEnd === ""
          ) {
            // 指标 下拉 数据
            this.zbOption = [];
            if (res.data["zb"] !== null && res.data["zb"].length > 0) {
              this.zbEmpty = false;
              res.data["zb"].forEach((i) => {
                const item = {};
                item.label = i.val;
                item.value = i.val;
                this.zbOption.push(item);
              });
            } else {
              this.zbEmpty = true;
              this.zbOption = [];
              const item = {};
              item["label"] = "The index data of the selected FTZ has not been published. Please select another FTZ";
              item["value"] = "The index data of the selected FTZ has not been published. Please select another FTZ";
              this.zbOption2 = [];
              this.zbModel2 = [];
              this.zbOption2.push(item);
              this.zbModel2.push(item["value"]);
            }
            // 时间 下拉数据
            this.yearData = [];
            this.yearData = res.data["data"];
          }
          // 使用 指标 调用接口
          if (
            ftaIdStr === "" &&
            indStr !== "" &&
            yearStart === "" &&
            yearEnd === ""
          ) {
            this.zmqOption = [];
            if (res.data["fta"] !== null && res.data["fta"].length > 0) {
              this.zmqEmpty = false;
              res.data["fta"].forEach((i) => {
                const item = {};
                item.label = i.val;
                item.value = i.val;
                this.zmqOption.push(item);
              });
            } else {
              this.zmqEmpty = true;
              this.zmqOption = [];
              const item = {};
              item["label"] = "There is no FTZ to filter and compare. Please change the index and try again";
              item["value"] = "There is no FTZ to filter and compare. Please change the index and try again";
              this.zmqOption2 = [];
              this.zmqModel2 = [];
              this.zmqOption2.push(item);
              this.zmqModel2.push(item["value"]);
            }
            this.yearData = [];
            this.yearData = res.data["data"];
          }
          // 使用 开始年份 和 结束年份 调用接口
          if (
            ftaIdStr === "" &&
            indStr === "" &&
            yearStart !== "" &&
            yearEnd !== ""
          ) {
            this.zmqOption = [];
            if (res.data["fta"] !== null && res.data["fta"].length > 0) {
              this.zmqEmpty = false;
              res.data["fta"].forEach((i) => {
                const item = {};
                item.label = i.val;
                item.value = i.val;
                this.zmqOption.push(item);
              });
            } else {
              this.zmqEmpty = true;
              this.zmqOption = [];
              const item = {};
              item["label"] = "There is no FTZ to filter and compare. Please change the index and try again";
              item["value"] = "There is no FTZ to filter and compare. Please change the index and try again";
              this.zmqOption2 = [];
              this.zmqModel2 = [];
              this.zmqOption2.push(item);
              this.zmqModel2.push(item["value"]);
            }
            // 指标 下拉 数据
            this.zbOption = [];
            if (res.data["zb"] !== null && res.data["zb"].length > 0) {
              this.zbEmpty = false;
              res.data["zb"].forEach((i) => {
                const item = {};
                item.label = i.val;
                item.value = i.val;
                this.zbOption.push(item);
              });
            } else {
              this.zbEmpty = true;
              this.zbOption = [];
              const item = {};
              item["label"] = "The index data of the selected FTZ has not been published. Please select another FTZ";
              item["value"] = "The index data of the selected FTZ has not been published. Please select another FTZ";
              this.zbOption2 = [];
              this.zbModel2 = [];
              this.zbOption2.push(item);
              this.zbModel2.push(item["value"]);
            }
          }
          // 使用 自贸区 和 指标 调用接口
          if (
            ftaIdStr !== "" &&
            indStr !== "" &&
            yearStart === "" &&
            yearEnd === ""
          ) {
            this.yearData = [];
            this.yearData = res.data["data"];
          }
          // 使用 自贸区 和 年份 调用接口
          if (
            ftaIdStr !== "" &&
            indStr === "" &&
            yearStart !== "" &&
            yearEnd !== ""
          ) {
            // 指标 下拉 数据
            this.zbOption = [];
            if (res.data["zb"] !== null && res.data["zb"].length > 0) {
              this.zbEmpty = false;
              res.data["zb"].forEach((i) => {
                const item = {};
                item.label = i.val;
                item.value = i.val;
                this.zbOption.push(item);
              });
            } else {
              this.zbEmpty = true;
              this.zbOption = [];
              const item = {};
              item["label"] = "The index data of the selected FTZ has not been published. Please select another FTZ";
              item["value"] = "The index data of the selected FTZ has not been published. Please select another FTZ";
              this.zbOption2 = [];
              this.zbModel2 = [];
              this.zbOption2.push(item);
              this.zbModel2.push(item["value"]);
            }
          }
          // 使用 指标 和 年份 调用接口
          if (
            ftaIdStr === "" &&
            indStr !== "" &&
            yearStart !== "" &&
            yearEnd !== ""
          ) {
            this.zmqOption = [];
            if (res.data["fta"] !== null && res.data["fta"].length > 0) {
              this.zmqEmpty = false;
              res.data["fta"].forEach((i) => {
                const item = {};
                item.label = i.val;
                item.value = i.val;
                this.zmqOption.push(item);
              });
            } else {
              this.zmqEmpty = true;
              this.zmqOption = [];
              const item = {};
              item["label"] = "There is no free trade zone to FTZ. Please change the index and try again";
              item["value"] = "There is no free trade zone to FTZ. Please change the index and try again";
              this.zmqOption2 = [];
              this.zmqModel2 = [];
              this.zmqOption2.push(item);
              this.zmqModel2.push(item["value"]);
            }
          }
        }
      });
    },
    zbOnchange(e) {
      if (!e) {
        if (!this.isAllData) {
          if (this.count === 0) {
            this.first = "zb";
            this.zmqModel = [];
            // this.yearStartTime = "";
            // this.yearEndTime = "";
            let indStr = "";
            this.zbModel.forEach((i) => {
              let item = this.zbdbData["zb"].find((j) => j.val === i);
              if (indStr === "") {
                indStr = item["id"];
              } else {
                indStr = indStr + "," + item["id"];
              }
            });
            this.queryOnchange(
              "",
              indStr,
              this.yearStartTime,
              this.yearEndTime
            );
            this.count++;
          } else {
            if (this.zbModel.length > 0) {
              // if (this.onchange) {
              let indStr = "";
              this.zbModel.forEach((i) => {
                let item = this.zbdbData["zb"].find((j) => j.val === i);
                if (indStr === "") {
                  indStr = item["id"];
                } else {
                  indStr = indStr + "," + item["id"];
                }
              });
              // 第一个改变的 指标
              if (this.first === "zb") {
                // this.zmqModel = [];
                // this.yearStartTime = "";
                // this.yearEndTime = "";
                let indStr = "";
                this.zbModel.forEach((i) => {
                  let item = this.zbdbData["zb"].find((j) => j.val === i);
                  if (indStr === "") {
                    indStr = item["id"];
                  } else {
                    indStr = indStr + "," + item["id"];
                  }
                });
                this.queryOnchange(
                  "",
                  indStr,
                  this.yearStartTime,
                  this.yearEndTime
                );
              }
              // 第一个改变的 自贸区
              if (this.first === "zmq") {
                // if (this.zmqModel.length === 0) {
                  let yearStrat = this.yearStartTime;
                  let yearEnd = this.yearEndTime;
                  this.queryOnchange("", indStr, yearStrat, yearEnd);
                // } else {
                //   let ftaIdStr = "";
                //   this.zmqModel.forEach((i) => {
                //     let item = this.zbdbData["fta"].find((j) => j.val === i);
                //     if (ftaIdStr === "") {
                //       ftaIdStr = item["id"];
                //     } else {
                //       ftaIdStr = ftaIdStr + "," + item["id"];
                //     }
                //   });
                //   this.queryOnchange(ftaIdStr, indStr);
                // }
              }
              // 第一个改变的 指标
              if (this.first === "year") {
                let yearStrat = this.yearStartTime;
                let yearEnd = this.yearEndTime;
                this.queryOnchange("", indStr, yearStrat, yearEnd);
              }
              // this.onchange = false;
              // }
            } else {
              if (this.zmqModel.length === 0) {
                this.queryOnchange(
                  "",
                  "",
                  this.yearStartTime,
                  this.yearEndTime
                );
                console.log("qqqqqqqq");
              } else {
                let ftaIdStr = "";
                this.zmqModel.forEach((i) => {
                  let item = this.zbdbData["fta"].find((j) => j.val === i);
                  if (ftaIdStr === "") {
                    ftaIdStr = item["id"];
                  } else {
                    ftaIdStr = ftaIdStr + "," + item["id"];
                  }
                });
                this.queryOnchange(
                  ftaIdStr,
                  "",
                  this.yearStartTime,
                  this.yearEndTime
                );
                console.log("ppppppp");
              }
            }
          }
        }
      }
    },
    yearStartOnchange() {
      if (!this.isAllData) {
        if (this.count === 0) {
          this.first = "year";
          this.zmqModel = [];
          this.zbModel = [];
          let yearStart = this.yearStartTime;
          let yearEnd = this.yearEndTime;
          this.queryOnchange("", "", yearStart, yearEnd);
          this.count++;
        } else {
          if (this.yearStartTime !== "" && this.yearEndTime !== "") {
            this.zmqModel = [];
            this.zbModel = [];
            let yearStart = this.yearStartTime;
            let yearEnd = this.yearEndTime;
            this.queryOnchange("", "", yearStart, yearEnd);
            this.count++;
            // if (this.onchange) {
            // this.zmqModel = [];
            // this.zbModel = [];
            // console.log("yearChange", this.onchange);
            // if (this.first === "year") {
            //   if (this.zmqModel.length !== 0 && this.zbModel.length === 0) {
            //     let ftaIdStr = "";
            //     this.zmqModel.forEach((i) => {
            //       let item = this.zbdbData["fta"].find((j) => j.val === i);
            //       if (ftaIdStr === "") {
            //         ftaIdStr = item["id"];
            //       } else {
            //         ftaIdStr = ftaIdStr + "," + item["id"];
            //       }
            //     });
            //     let yearStart = this.yearStartTime;
            //     let yearEnd = this.yearEndTime;
            //     this.queryOnchange(ftaIdStr, "", yearStart, yearEnd);
            //   } else if (
            //     this.zmqModel.length === 0 &&
            //     this.zbModel.length !== 0
            //   ) {
            //     let indStr = "";
            //     this.zbModel.forEach((i) => {
            //       let item = this.zbdbData["zb"].find((j) => j.val === i);
            //       if (indStr === "") {
            //         indStr = item["id"];
            //       } else {
            //         indStr = indStr + "," + item["id"];
            //       }
            //     });
            //     let yearStart = this.yearStartTime;
            //     let yearEnd = this.yearEndTime;
            //     this.queryOnchange("", indStr, yearStart, yearEnd);
            //   } else {
            //     if (this.zmqModel.length) this.first = "year";
            //     // this.zmqModel = [];
            //     // this.zbModel = [];
            //     let yearStart = this.yearStartTime;
            //     let yearEnd = this.yearEndTime;
            //     this.queryOnchange("", "", yearStart, yearEnd);
            //   }
            // }
            // if (this.first === "zmq") {
            //   let ftaIdStr = "";
            //   this.zmqModel.forEach((i) => {
            //     let item = this.zbdbData["fta"].find((j) => j.val === i);
            //     if (ftaIdStr === "") {
            //       ftaIdStr = item["id"];
            //     } else {
            //       ftaIdStr = ftaIdStr + "," + item["id"];
            //     }
            //   });
            //   let yearStart = this.yearStartTime;
            //   let yearEnd = this.yearEndTime;
            //   this.queryOnchange(ftaIdStr, "", yearStart, yearEnd);
            // }
            // if (this.first === "zb") {
            //   let indStr = "";
            //   this.zbModel.forEach((i) => {
            //     let item = this.zbdbData["zb"].find((j) => j.val === i);
            //     if (indStr === "") {
            //       indStr = item["id"];
            //     } else {
            //       indStr = indStr + "," + item["id"];
            //     }
            //   });
            //   let yearStart = this.yearStartTime;
            //   let yearEnd = this.yearEndTime;
            //   this.queryOnchange("", indStr, yearStart, yearEnd);
            // }
            // this.onchange = false;
            // }
          }
        }
      }
    },
    yearEndOnchange() {
      if (!this.isAllData) {
        if (this.count === 0) {
          this.first = "year";
          this.zmqModel = [];
          this.zbModel = [];
          let yearStart = this.yearStartTime;
          let yearEnd = this.yearEndTime;
          this.queryOnchange("", "", yearStart, yearEnd);
          this.count++;
        } else {
          if (this.yearStartTime !== "" && this.yearEndTime !== "") {
            this.zmqModel = [];
            this.zbModel = [];
            let yearStart = this.yearStartTime;
            let yearEnd = this.yearEndTime;
            this.queryOnchange("", "", yearStart, yearEnd);
            this.count++;
            // if (this.onchange) {
            // console.log("yearChange2", this.onchange);
            // if (this.first === "year") {
            //   if (this.zmqModel.length !== 0 && this.zbModel.length === 0) {
            //     let ftaIdStr = "";
            //     this.zmqModel.forEach((i) => {
            //       let item = this.zbdbData["fta"].find((j) => j.val === i);
            //       if (ftaIdStr === "") {
            //         ftaIdStr = item["id"];
            //       } else {
            //         ftaIdStr = ftaIdStr + "," + item["id"];
            //       }
            //     });
            //     let yearStart = this.yearStartTime;
            //     let yearEnd = this.yearEndTime;
            //     this.queryOnchange(ftaIdStr, "", yearStart, yearEnd);
            //   } else if (
            //     this.zmqModel.length === 0 &&
            //     this.zbModel.length !== 0
            //   ) {
            //     let indStr = "";
            //     this.zbModel.forEach((i) => {
            //       let item = this.zbdbData["zb"].find((j) => j.val === i);
            //       if (indStr === "") {
            //         indStr = item["id"];
            //       } else {
            //         indStr = indStr + "," + item["id"];
            //       }
            //     });
            //     let yearStart = this.yearStartTime;
            //     let yearEnd = this.yearEndTime;
            //     this.queryOnchange("", indStr, yearStart, yearEnd);
            //   } else {
            //     if (this.zmqModel.length) this.first = "year";
            //     // this.zmqModel = [];
            //     // this.zbModel = [];
            //     let yearStart = this.yearStartTime;
            //     let yearEnd = this.yearEndTime;
            //     this.queryOnchange("", "", yearStart, yearEnd);
            //   }
            // }
            // if (this.first === "zmq") {
            //   let ftaIdStr = "";
            //   this.zmqModel.forEach((i) => {
            //     let item = this.zbdbData["fta"].find((j) => j.val === i);
            //     if (ftaIdStr === "") {
            //       ftaIdStr = item["id"];
            //     } else {
            //       ftaIdStr = ftaIdStr + "," + item["id"];
            //     }
            //   });
            //   let yearStart = this.yearStartTime;
            //   let yearEnd = this.yearEndTime;
            //   this.queryOnchange(ftaIdStr, "", yearStart, yearEnd);
            // }
            // if (this.first === "zb") {
            //   let indStr = "";
            //   this.zbModel.forEach((i) => {
            //     let item = this.zbdbData["zb"].find((j) => j.val === i);
            //     if (indStr === "") {
            //       indStr = item["id"];
            //     } else {
            //       indStr = indStr + "," + item["id"];
            //     }
            //   });
            //   let yearStart = this.yearStartTime;
            //   let yearEnd = this.yearEndTime;
            //   this.queryOnchange("", indStr, yearStart, yearEnd);
            // }
            // this.onchange = false;
            // }
          }
        }
      }
    },
    changeYears(data) {
      console.log("父组件接受");
      this.yearStartTime = data.startTime;
      this.yearEndTime = data.endTime;
    },
    /**
     * 改变 开启 关闭 全部数据
     */
    changeAllData() {
      this.initQueryDropDownBox();
    },
    /**
     * 页面初始化接口
     * 1、获取指标对比下拉框信息
     */
    initQueryDropDownBox() {
      let allData = this.isAllData ? 1 : 0;
      request(
        "get",
        `${baseUrl.base_1}/indexCompare/queryDropDownBox?allData=${allData}`
      ).then((res) => {
        if (res.resCode === 0) {
          this.zbdbData = res.data;
          // 自贸区 下拉 数据
          this.zmqEmpty = false;
          this.zmqOption = [];
          this.zbdbData["fta"].forEach((i) => {
            const item = {};
            item.label = i.val;
            item.value = i.val;
            this.zmqOption.push(item);
          });
          // 指标 下拉 数据
          this.zbEmpty = false;
          this.zbOption = [];
          this.zbdbData["zb"].forEach((i) => {
            const item = {};
            item.label = i.val;
            item.value = i.val;
            this.zbOption.push(item);
          });
          // 时间 下拉数据
          this.yearData = [];
          // this.yearStartTime = this.zbdbData["data"][0]["val"];
          // this.yearEndTime =
          //   this.zbdbData["data"][this.zbdbData["data"].length - 1]["val"];
          this.yearStartTime = "";
          this.yearEndTime = "";
          this.yearData = this.zbdbData["data"];
          this.initQueryInit();
        }
      });
    },
    /**
     * 初始化 自贸区 指标 年份 绑定的数据
     */
    initQueryInit() {
      let allData = this.isAllData ? 1 : 0;
      request(
        "get",
        `${baseUrl.base_1}/indexCompare/queryInit?allData=${allData}`
      ).then((res) => {
        if (res.resCode === 0) {
          this.zbdbModel = res.data;
          // 自贸区 下拉 数据
          this.zmqModel = [];
          this.zbdbModel["fta"].forEach((i) => {
            this.zmqModel.push(
              this.zbdbData["fta"].find((j) => i === j.id)["val"]
            );
          });
          // 指标 下拉 数据
          this.zbModel = [];
          this.zbdbModel["zb"].forEach((i) => {
            this.zbModel.push(
              this.zbdbData["zb"].find((j) => i === j.id)["val"]
            );
          });
          // 时间 下拉数据
          this.yearStartTime = this.zbdbModel["data"][0];
          this.yearEndTime =
            this.zbdbModel["data"][this.zbdbModel["data"].length - 1];
          this.searchQuery();
        }
      });
    },
    /**
     * 统一查询接口
     */
    searchQuery() {
      // let allData = this.isAllData ? 1 : 0;
      let ftaIdStr = "";
      this.zmqModel.forEach((i) => {
        let item = this.zbdbData["fta"].find((j) => j.val === i);
        if (ftaIdStr === "") {
          ftaIdStr = item["id"];
        } else {
          ftaIdStr = ftaIdStr + "," + item["id"];
        }
      });
      let indStr = "";
      if (this.zbModel[0] !== "The index data of the selected FTZ has not been published. Please select another FTZ") {
        this.zbModel.forEach((i) => {
          let item = this.zbdbData["zb"].find((j) => j.val === i);
          if (indStr === "") {
            indStr = item["id"];
          } else {
            indStr = indStr + "," + item["id"];
          }
        });
      }
      let yearStart = "";
      let yearEnd = "";
      if (this.yearStartTime !== null && this.yearEndTime === null) {
        yearStart = this.yearStartTime;
        this.yearEndTime =
          this.yearData[this.yearData.length - 1]["val"].toString();
        yearEnd = this.yearEndTime;
      }
      if (this.yearStartTime === null && this.yearEndTime !== null) {
        this.yearStartTime = this.yearData[0]["val"].toString();
        yearStart = this.yearStartTime;
        yearEnd = this.yearEndTime;
      }
      if (this.yearStartTime !== null && this.yearEndTime !== null) {
        yearStart = this.yearStartTime;
        yearEnd = this.yearEndTime;
      }
      if (this.yearStartTime === null && this.yearEndTime === null) {
        this.yearEndTime = this.charYearDisplay[1].toString();
        this.yearStartTime = this.charYearDisplay[0].toString();
        yearEnd = this.yearEndTime;
        yearStart = this.yearStartTime;
      }
      request(
        "get",
        `${baseUrl.base_1}/indexCompare/query?ftaIdStr=${ftaIdStr}&indStr=${indStr}&yearEnd=${yearEnd}&yearStart=${yearStart}`
      ).then((res) => {
        if (res.resCode === 0) {
          this.charDataDisplay = res.data;
          // 点击确定后 定义 表格 数据
          this.excel.zbModel = this.zbModel;
          this.excel.zmqModel = this.zmqModel;
          this.excel.yearStartTime = this.yearStartTime;
          this.excel.yearEndTime = this.yearEndTime;
          // 渲染 选中指标 对应的图表·
          this.charZbDisplay = this.zbModel;
          this.charZmqDisplay = this.zmqModel;
          let item = [];
          let i = parseInt(this.yearStartTime);
          while (i <= parseInt(this.yearEndTime)) {
            item.push(i);
            i++;
          }
          this.charYearDisplay = item;
        }
      });
    },
    // 点击确定 按钮
    submit() {
      if (this.zmqModel.length === 0) {
        this.$message({
          message: "Please select a FTZ",
          type: "warning",
        });
        return;
      }
      if (this.zbModel.length === 0) {
        this.$message({
          message: "Please select an index",
          type: "warning",
        });
        return;
      }
      // if (this.yearStartTime === "") {
      //   this.$message({
      //     message: "请选择开始日期",
      //     type: "warning",
      //   });
      //   return;
      // }
      // if (this.yearEndTime === "") {
      //   this.$message({
      //     message: "请选择结束日期",
      //     type: "warning",
      //   });
      //   return;
      // }
      this.searchQuery();
      this.count = 0;
      this.onchange = true;
    },
    downLoadExcelzb(name) {
      console.log("下载文件");
      let json = {};
      json["fields"] = this.ExcelFields;
      json["data"] = this.ExcelData;
      // const fd = new FormData();
      // fd.append("dataJsonStr", JSON.stringify(json));
      console.log(encodeURI(JSON.stringify(json).trim()));
      request("post", `${baseUrl.base_1}/indexCompare/download`, {
        dataJsonStr: JSON.stringify(json),
      }).then((res) => {
        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
        let url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = name; // 重命名文件
        link.download.trim();
        link.click();
        window.URL.revokeObjectURL(url); // 释放内存
        // this.fullscreenLoading = false;
        loading.close();
      });
    },
  },
  mounted() {
    /**
     * 页面初始化-先调用queryDropDownBox-渲染三个下拉数据
     */
    this.initQueryDropDownBox();
  },
  watch: {
    zmqZbEmpty(val) {
      if (val) {
        // console.log("指标和年份都为空");
        this.yearData = this.zbdbData["data"];
      }
    },
    zmqModel(val) {
      // console.log("自贸区", val);
      if (this.zmqModel.length > 5) {
        this.$message("Up to 5 FTZ can be selected");
        this.zmqModel.splice(5, 1);
      }
      if (this.zmqModel.length === 0) {
        // console.log("自贸区清空1");
        // 自贸区 清空时
        // 重置 指标应该为 4个
        this.zbOption = [];
        this.zbdbData["zb"].forEach((i) => {
          const item = {};
          item.label = i.val;
          item.value = i.val;
          this.zbOption.push(item);
        });
      }
    },
    zbModel(val) {
      console.log("指标", val);
      if (this.zbModel.length === 0) {
        console.log("自贸区清空1");
        // 自贸区 清空时
        // 重置 指标应该为 4个
        this.zmqOption = [];
        this.zbdbData["fta"].forEach((i) => {
          const item = {};
          item.label = i.val;
          item.value = i.val;
          this.zmqOption.push(item);
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.echarts {
  z-index: 90;
  position: absolute !important;
  width: calc(100% - 30px);
  height: calc(100% - 25px);
}

// /deep/#jckze1 {
//   > div {
//     width: 100% !important;
//     height: 100% !important;
//   }
// }
// /deep/#jckze2 {
//   > div {
//     width: 100% !important;
//     height: 100% !important;
//   }
// }
// /deep/#xzqy1 {
//   > div {
//     width: 100% !important;
//     height: 100% !important;
//   }
// }
// /deep/#xzqy2 {
//   > div {
//     width: 100% !important;
//     height: 100% !important;
//   }
// }
// /deep/#xzwz1 {
//   > div {
//     width: 100% !important;
//     height: 100% !important;
//   }
// }
// /deep/#xzwz2 {
//   > div {
//     width: 100% !important;
//     height: 100% !important;
//   }
// }
// /deep/#ns1 {
//   > div {
//     width: 100% !important;
//     height: 100% !important;
//   }
// }
// /deep/#ns2 {
//   > div {
//     width: 100% !important;
//     height: 100% !important;
//   }
// }
// 新增 指标对比
.zbdb {
  .titleBox {
    width: 98%;
    padding-left: 30px;
    padding-right: 30px;
    margin: 0 0 0 1%;
    height: 50px;
    line-height: 50px;
    display: flex;
    justify-content: space-between;
  }
  .bigTitleInfo {
    // font-family:SourceHanSansCN-Bold;
    font-size: 16px;
    color: #409eff;
    letter-spacing: -0.32px;
    // padding-left: 20px;
    font-weight: bold;
  }

  .center {
    display: flex;
    flex-direction: column;

    .top {
      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 30px;
      padding-right: 30px;
      width: 100%;
      // height: 60px;
      // background-color: rebeccapurple;
      display: flex;
      flex-direction: row;

      .top-form {
        display: flex;
        flex-direction: row;
        height: 100%;
        flex-grow: 1;

        // background-color: royalblue;
        // border: 1px solid #ddd;
        .zb {
          width: 35%;
        }

        .item {
          // flex-grow: 1;
          width: 100%;
          margin-left: 10px;
          margin-right: 10px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          .year-range {
            border: 1px solid #ddd;
          }
        }

        .item {
          /deep/.el-select {
            flex-grow: 1;
          }

          /deep/.el-select__tags {
            flex-wrap: nowrap !important;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          /deep/.is-focus {
            border: 1px solid #409eff !important;
          }

          /deep/.el-tag__close,
          .el-icon-close {
            display: none;
          }

          /deep/.el-tag {
            font-size: 14px;
            color: #666;
            border: none !important;
            border-radius: 0px !important;
            border-right: 1px solid #ddd !important;
            background-color: transparent !important;
          }

          /deep/.el-input__inner {
            border-radius: 0;
          }
          /deep/.el-date-editor {
            width: 90px;
            border: none !important;
          }
          .el-date-editor {
            /deep/.el-input__inner {
              padding-right: 0 !important;
              border: none !important;
            }
          }
          .endYear,
          .startYear {
            /deep/.el-input__inner {
              text-align: center !important;
              padding-left: 0 !important;
              padding-right: 0 !important;
              border: none !important;
            }
            /deep/.el-input__icon {
              display: none;
            }
          }
        }
      }

      .top-botton {
        padding-left: 10px;
        display: flex;
        align-items: center;
        justify-content: end;
        height: 100%;

        // background-color: green;
        /deep/.el-button {
          border-radius: 0;
        }
      }
    }

    .bottom {
      padding: 20px;
      width: 100%;
      height: 450px;
      // border: 1px solid #ddd;
      // background-color: goldenrod;
      display: flex;
      flex-direction: row;
      .item {
        padding-top: 15px;
        padding-bottom: 10px;
        padding-left: 15px;
        padding-right: 15px;
        border-radius: 3px;
        position: relative;
        margin-left: 10px;
        margin-right: 10px;
        height: 100%;
        // flex-grow: 1;
        width: 100%;
        border-radius: 4px;
        // background-color: rosybrown;
        // border: 1px solid #ddd;
        background-color: #fbfbfb;
        .box {
          width: 100%;
          height: 100%;
          .check {
            z-index: 100;
            right: 15px;
            top: 15px;
            position: absolute;
            width: 89px;
            height: 42px;
            // background-color: rebeccapurple;
            display: flex;
            justify-content: space-between;
            img {
              cursor: pointer;
              width: 42px;
              height: 42px;
            }
          }
        }
      }
    }
  }
}
</style>
